import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import Layout from 'components/Layout';

import HomeContainer from 'containers/HomeContainer';
import AboutContainer from 'containers/AboutContainer';
import LookbookContainer from 'containers/LookbookContainer';
import CatalogContainer from 'containers/CatalogContainer';
import ShoplistContainer from 'containers/ShoplistContainer';
import ContactContainer from 'containers/ContactContainer';
import PaletteContainer from 'containers/PaletteContainer';
import GalleryContainer from 'containers/GalleryContainer';

import { Header } from 'components/Shared';
import { Footer } from 'components/Shared';

class App extends Component {
  render() {
    return (
      <Layout>
        <Route path="/" component={Header}/>
        <Route path="/" component={PaletteContainer}/>

        <Switch>
          <Route exact path="/" component={HomeContainer}/>
          <Route exact path="/about" component={AboutContainer}/>
          <Route exact path="/lookbook" component={LookbookContainer}/>
          <Route exact path="/gallery/:index" component={GalleryContainer}/>
          <Route path="/lookbook/:season" component={CatalogContainer}/>
          <Route exact path="/shoplist" component={ShoplistContainer}/>
          <Route exact path="/contact" component={ContactContainer}/>
          <Redirect to="/"/>
        </Switch>

        <Route path="/" component={Footer}/>
      </Layout>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js